import { analytics, shapes } from "ionicons/icons";
import { TaalType } from "./interfaceTypes";
import {Shruti, CompositionMem,MeasureMem,PhraseMem, VibhagMem,NoteMem,
    ComplexNoteMem,ParsedToken,NoteType,Slide,Token, Marker,TempoGenre, normalizeComplexNoteMem}

 from "./interfaceTypes";


  /*
  interface Vibhag {
    notesToken:ParsedToken[],
    notes:NoteType[],
    carryMeend:boolean,
    carryGun:number,
    taalVibhagId?:string;
    lyrics?:string;
  }
  interface Measure1 {
    notesToken:ParsedToken[],
    vibhags:Vibhag[],
    carryMeend:boolean,
    carryGun:number
  }
  interface Composition1
  {
    bpmeasure:number;
    tempo: number;
    taal:string,
    taalId:number,
    measures:Measure1 [];
  }
*/

    

/*

SaReGa Notation System
'
S R G  m P D N -> Shuddh 
r g d n -> Komal
M -> Tivra 

'-' Silence 

'~' Sustainenance of last note  - takes duration
$  Andoloan of last note - takes duration and can be stand alone, in which case preceding note in andolan

[(]->Next note is start of meend
[)]-> Previous note was last note of the meend

(k ?) - Kan Note
(m ?) - Murki note
(2 -> Each beat now is Dugun instead of single beat - until  )or '|' or '||. Can not span across phrases

(3  -> Each beat is now  Tigun )
(4 -> Each Beat is now chougun)

':'->Explicit beat Seperator
'|' -> Vibhag Seperator
'||' ->Measure Seperator
',' -> Break sound. No duration
';' -> Breath sound - duration as per meter

Kan ::= <Token.Kan> <Shruti> <Token.CloseBracket>;
Murki ::=<Token.Murki> <Shruti> {Shruti|Token.sustain} <Token.CloseBracket>
ComplexNote ::= [Token.MeendBegin] [Kan | Murki ] <Shruti> [{Token.PRE_GRACE | Token.POST_GRACE} <Shruti>] [kan] [TokenMeendEnd|]

BeatSequence ::= { ComlexNote| Token.silence | Token.sustain |  Token.breath| Token.BRSOUND }
Phrase= series of Beat Sequence seperated either by  Token.MEASURE  | TOKEN.SPACE | Token.VSEP 

*/



  
  type TokenType = keyof typeof Token | keyof typeof Shruti | "NUMBER" | "UNKNOWN";
  
  
  interface CompositionNode {
    measures: MeasureNode[];
  }
  
  interface MeasureNode {
    vibhags: VibhagNode[];
    terminatorToken: ParsedToken;
  }
  
  interface VibhagNode {
    phrases: PhraseNode[];
    terminatorToken?: ParsedToken;
  }
  
  interface PhraseNode {
    beats: BeatSequenceNode[];
    terminatorToken?: ParsedToken;
  }
  
  interface BeatSequenceNode {
    type: "ComplexNote" | "BREATH" | "SUSTAIN" | "SILENCE";
    complexNote?: ComplexNoteNode;
    token?: ParsedToken;
  }
  
  interface ComplexNoteNode {
    tokens: ParsedToken[];
    inner: {
      meendStart?: ParsedToken;
      kanBefore?: KanNode;
      murki?: MurkiNode;
      mainShruti: ParsedToken;
      kanAfter?: KanNode;
      meendEnd?: ParsedToken;
    };
  }
  
  interface KanNode {
    kanToken: ParsedToken;
    shruti: ParsedToken;
    close: ParsedToken;
  }
  
  interface MurkiNode {
    murkiToken: ParsedToken;
    shrutis: ParsedToken[];
    close: ParsedToken;
  }
  enum NoteState{
    NONE="",
    GUNBRACKET="G",
    DECO='D ',
    NOTE="N",
    NOTEOCTAVED="NV"

}


export function  shrutiToOmenad(str:string)
{
  // remove leading spaces.
  str=str.trim();
  let octave='';
  let note="";
  if (str.indexOf('.')==1)
      octave='l';
  else if (str.indexOf("'")==1)
      octave='u';
  switch(str.substring(0,1))
  {
      case "s":
      case "S":
          note="s";
          break;
          case 'p':
          case "P":
              note="p";
              break;
      case "R":
      case "D":
      case "P":
      case "N":
        case "G":
          note=str.substring(0,1).toLowerCase();
          break;
      case "r":
      case "g":
      case "d":
      case "n":
          note=str.substring(0,1).toUpperCase();

      break;
      default: note=str.substring(0,1)

  }

  return (note+octave)

}

export function beatToOmad(beat:PhraseMem,language:string)
{
    let gunChar="";
    if (!language)
        language='en';

    let result:{gunChar:string,subBeats:any[]}={ gunChar:"", subBeats:[]};
    if ((language=='en')||(language=='hi'))
    {
        let div=beat.div;
        switch(div)
        {
            case 2: gunChar='@';
            break;
            case 3: gunChar='#';
            break;
            case 4:
                gunChar='$';
                break;
             case 5:
                    gunChar='%';
                    break;
            case 7:
                        gunChar='&';
                        break;
            case 8:
                            gunChar='*';
                            break;

        };
        result.gunChar=gunChar;
        beat.notes?.forEach ((n)=>{
            let pre="";
            let preHtml="";
            let post="";
            let meend="";
            let postHtml="";
            let shrutiText="";
            let c:ComplexNoteMem | undefined = normalizeComplexNoteMem(n.complexNote as ComplexNoteMem);
            const hasRenderableComplexNote = Boolean(
              c &&
              (
                c.shruti ||
                c.kanBefore ||
                c.kanAfter ||
                (c.murki && c.murki.length > 0) ||
                c.meendStart ||
                c.meendCont ||
                c.meendEnd
              )
            );
            
            let noteChar="";
            if (hasRenderableComplexNote && c)
            {
               if (c.meendStart)
                    meend='q';
                else if (c.meendCont)
                    meend='w'
                if (c.meendEnd)
                    meend='e'
                if (c.murki && c.murki.length >0)
                {
                    pre='('+c.murki +')';

                }
                else if (c.kanBefore)
                    preHtml=c.kanBefore;
                if (c.kanAfter)
                    postHtml=c.kanAfter;
                if (!c.shruti)
                {
                    throw ("Shruti expected");
                    return;
                }
                else
                noteChar=shrutiToOmenad(c.shruti)

            }
            else
            if (n.special)
            {
                if (n.special.value==Token.SUSTAIN)
                        noteChar='~';
                if (n.special.value==Token.SILENCE)
                    noteChar='-';
                if (n.special.value==Token.BREATH)
                    noteChar=',';
            }
            result.subBeats.push(
                {
noteChar:noteChar,
preHtml:preHtml,
post:postHtml,
meend:meend,
pre:pre
                }
            )
            
        });

    }
return result;
}


function printToOAMAD(measures:MeasureMem[],vibhags?:number[],lan?:string)
{
if (!lan)
    lan='en';
   let compositionDisplay:any[]=[];
    measures.forEach(element => {

        // do lyrics
        let lyrics:any=[];
        let VibhagBeatsDisplay:any[]=[];
        let VibhagTaalDisplay:any[]=[];
        let omadtext="";
        let measureDisplay:any[]=[];
        let taalDisplay=[]
        element.vibhag.forEach((v)=>
        {
            let beatdisplay:any[]=[];
            let taalDisplay:any[]=[];
            if (v.lyrics)
            {
                lyrics.push('v.lyrics')
            }
            if (v.beats )
            {
                v.beats.forEach((beat,ix)=>
                {
                    taalDisplay.push(ix+1)
                   let beatText= beatToOmad(beat,lan)
                
                beatdisplay.push(beatText)
                })

            }
            VibhagBeatsDisplay.push(beatdisplay)
            VibhagTaalDisplay.push(taalDisplay)
        });
        measureDisplay.push({lyrics:lyrics,beats:VibhagBeatsDisplay, taal:VibhagTaalDisplay})
        //do notes
        // do tabla 
        // print end of of measure
        omadtext+='A'
        compositionDisplay.push(measureDisplay)
    });
    return compositionDisplay;

}

  export class CompositionParser {
    tokens: ParsedToken[];
    index = 0;
  
    constructor(tokens: ParsedToken[]) {
      this.tokens = tokens;
    }
  
    parseComposition(): CompositionNode {
      const measures: MeasureNode[] = [];
      while (this.index < this.tokens.length) {
        measures.push(this.parseMeasure());
      }
      return { measures };
    }
  
    parseMeasure(): MeasureNode {
      const vibhags: VibhagNode[] = [];
      vibhags.push(this.parseVibhag());
  
      while (this.peek()?.value === Token.VSEP) {
        this.next();
        vibhags.push(this.parseVibhag());
      }
  
      const terminator = this.expect(Token.MEASURE);
      return { vibhags, terminatorToken: terminator };
    }
  
    parseVibhag(): VibhagNode {
      const phrases: PhraseNode[] = [];
      let lastPp:PhraseNode|null=null;
      phrases.push(this.parsePhrase());
  
      while (this.peek()?.value === Token.SPACE ) {
        this.next();
        phrases.push(this.parsePhrase());
      }
  
      let terminatorToken: ParsedToken | undefined = undefined;
      const next = this.peek();
     
      if (next?.value === Token.VSEP )
         {
        terminatorToken = {value:Token.VSEP, type:next?.type}
        //this.next();
      }
      // do not pop
      if (next?.value === Token.MEASURE)
      {
        terminatorToken = {value:next?.value, type:next?.type}
      }
      
      return { phrases, terminatorToken };
    }
  

    parsePhrase(): PhraseNode {
      const beats: BeatSequenceNode[] = [];
      let lastBeatSeq:BeatSequenceNode|null=null;
      while (true) {
        const next = this.peek();

        if (!next || next.value === Token.VSEP || next.value === Token.MEASURE|| next.value===Token.SPACE)  break;
       
        beats.push(lastBeatSeq=this.parseBeatSequence());
      }
     // shared terminators..
     
      let terminatorToken: ParsedToken | undefined = undefined;
      const next = this.peek();
      if ( next?.value===Token.SPACE || next?.value === Token.VSEP || next?.value === Token.MEASURE || next?.value===Token.SPACE) {
        terminatorToken = next;
      }
  
      return { beats, terminatorToken };
    }
  


  parseBeatSequence(): BeatSequenceNode {
    const next = this.peek();
    if (!next) throw this.error("Unexpected end of input in beat sequence");

    if (next.value === Token.BREATH || next.value === Token.SUSTAIN || next.value === Token.SILENCE) {
      return { type: next.type as BeatSequenceNode["type"], token: this.next()! };
    }

    const complexNote = this.parseComplexNote();
    return { type: "ComplexNote", complexNote };
  }
  
  
    parseComplexNote(): ComplexNoteNode {
      const tokens: ParsedToken[] = [];
      let meendStart: ParsedToken | undefined;
      let kanBefore: KanNode | undefined;
      let murki: MurkiNode | undefined;
      let meendEnd: ParsedToken | undefined;
  
      if (this.peek()?.value === Token.MEENDSTART) {
        meendStart = this.next();
        tokens.push(meendStart as ParsedToken);
      }
  
      const next = this.peek();
      if (next?.value === Token.KAN) {
        kanBefore = this.parseKan();
        tokens.push(kanBefore.kanToken, kanBefore.shruti, kanBefore.close);
      } else if (next?.value === Token.MURKI) {
        murki = this.parseMurki();
        tokens.push(murki.murkiToken, ...murki.shrutis, murki.close);
      }
  
      const mainShruti = this.expectShruti();
      tokens.push(mainShruti);
  
      let kanAfter: KanNode | undefined;
      const graceToken = this.peek();
      if (graceToken?.value === Token.PRE_GRACE || graceToken?.value === Token.POST_GRACE) {
        const graceMarker = this.next() as ParsedToken;
        const graceShruti = this.expectShruti();
        tokens.push(graceMarker, graceShruti);
        if (graceMarker.value === Token.PRE_GRACE) {
          kanBefore = {
            kanToken: graceMarker,
            shruti: graceShruti,
            close: graceShruti
          };
        } else {
          kanAfter = {
            kanToken: graceMarker,
            shruti: graceShruti,
            close: graceShruti
          };
        }
      } else if (this.peek()?.value === Token.KAN) {
        kanAfter = this.parseKan();
        tokens.push(kanAfter.kanToken, kanAfter.shruti, kanAfter.close);
      }
  
      if (this.peek()?.value === Token.MEENDEND) {
        meendEnd = this.next();
        tokens.push(meendEnd as ParsedToken);
      }
  
      return {
        tokens,
        inner: { meendStart, kanBefore, murki, mainShruti, kanAfter, meendEnd }
      };
    }
  
    parseKan(): KanNode {
      const kanToken = this.expect(Token.KAN);
      const shruti = this.expectShruti();
      const close = this.expect(Token.CLOSEBRACKET);
      return { kanToken, shruti, close };
    }
  
    parseMurkiContent()
    {
        const shrutis: ParsedToken[] = [this.expectShruti()];
        const next = this.peek();
        if (next)
            { if  (this.isShruti(next))
                
                shrutis.push(this.next()!);
              else throw ("Unexpected token")
            }
            return shrutis;
    }
    parseMurki(): MurkiNode {
      const murkiToken = this.expect(Token.MURKI);
      const shrutis: ParsedToken[] = [this.expectShruti()];
  
      const next = this.peek();
      if (next && (this.isShruti(next) || next.value === Token.SUSTAIN)) {
        shrutis.push(this.next()!);
      }
  
      const close = this.expect(Token.CLOSEBRACKET);
      return { murkiToken, shrutis, close };
    }
  
    expectShruti(): ParsedToken {
      const tok = this.next();
      if (!tok || !this.isShruti(tok)) {
        throw this.error(`Expected Shruti, got '${tok?.value}'`);
      }
      return tok;
    }
  
    expect(value: string): ParsedToken {
      const tok = this.next();
      if (!tok || tok.value !== value) {
        throw this.error(`Expected '${value}', got '${tok?.value}'`);
      }
      return tok;
    }
  
    expectTerminal(): ParsedToken {
      const term = this.next();
      if (!term || ![Token.SPACE, Token.VSEP, Token.MEASURE].includes(term.value as Token)) {
        throw this.error(`Expected terminal (SPACE, |, ||), got '${term?.value}'`);
      }
      return term;
    }
  
    next(): ParsedToken | undefined {
      return this.tokens[this.index++];
    }
  
    peek(): ParsedToken | undefined {
      return this.tokens[this.index];
    }
  
    isShruti(tok: ParsedToken): boolean {
      return Object.values(Shruti).includes(tok.value as Shruti);
    }
  
    error(msg: string): Error {
      const tok = this.tokens[this.index];
      return new Error(`Parse error at token ${this.index + 1} (${tok?.value ?? 'end'}): ${msg}`);
    }

    VibhagToText(vibhag:VibhagNode)
    {
        let result="";
        vibhag.phrases.forEach ((phrase,indx )=>{
           result +=this.phraseToText(phrase);
           indx++;
           if (indx < vibhag.phrases.length )
                result +=Token.VSEP;
        })
        return result;
    };

    phraseToText(phrase:PhraseNode)
    {
        let result="";
        phrase.beats.forEach((d:BeatSequenceNode,ix)=>{
            result+= this.beatToText(d);
            if (ix <(phrase.beats.length -1 ))
                result+=Token.SPACE;
        })
        return result;

    }
    beatToText(d:BeatSequenceNode)
    {
        let result="";
        if (d.type=='ComplexNote')
        {
             result+=this.complexNoteToText(d.complexNote as ComplexNoteNode)
        }
        else if (d.type=="SILENCE")
            result +=Token.SILENCE;
        if (d.type=='BREATH')
            result += Token.BREATH;
        if (d.type=='SUSTAIN')
            result += Token.SUSTAIN;
        
        return result;
    }
    complexNoteToText(comp:ComplexNoteNode)
    {
        let result=""
        if (comp && comp.inner)
        {
            if (comp.inner.meendStart)
            {
               result+= Token.MEENDSTART;

            }
            if (comp.inner.murki && (comp.inner.kanBefore || comp.inner.kanAfter))
            {
                throw("You may not combined Kan and Murki in same note");
                return;
            }
            if (comp.inner.murki)
            {
                result+= Token.MURKI + Token.SPACE+comp.inner.murki.shrutis.join()+Token.CLOSEBRACKET;

            }
            if (comp.inner.kanBefore)
                {
                    result+= comp.inner.mainShruti.value + Token.PRE_GRACE + comp.inner.kanBefore?.shruti;
                    
                }
            else if (comp.inner.mainShruti.value)
                {
                   result+= comp.inner.mainShruti.value;
                   
                }
                if (comp.inner.kanAfter)
                    {
                        result+= Token.POST_GRACE + comp.inner.kanAfter?.shruti;
                        
                    }
                    if (comp.inner.meendEnd)
                        {
                            result+= Token.MEENDEND ;
                                 
                        }
        };
        return result;
    }
    toText(measures:MeasureNode[])
    {
        let result="";
        measures.forEach ((measure:MeasureNode)=>{
        
            measure.vibhags.forEach((vibhag,ix)=>
            {
                result+=this.VibhagToText(vibhag);
                ix++;
                if (ix < measure.vibhags.length)
                    result+=Token.VSEP;
            });
            result+=Token.MEASURE +"\n";
            
        });
         return (result);
    }
   

    complexNoteToMem(comp:ComplexNoteNode)
    {
        let complexNote:ComplexNoteMem={
            meendStart:false, meendEnd:false,
            meendCont:false,
            kanBefore:null, kanAfter:null, 
            shruti:Token.SILENCE, indMidiKey:0, murki:[],
            andolan:false
        }
        
        if (comp && comp.inner)
        {
            if (comp.inner.meendStart)
            {
               complexNote.meendStart=true;

            }
            if (comp.inner.murki && (comp.inner.kanBefore || comp.inner.kanAfter))
            {
                throw("You may not combined Kan and Murki in same note");
                return;
            }
            if (comp.inner.murki)
            {
                let Shrutis=comp.inner.murki.shrutis.map ((d)=>{
                    return d.value ;
                });
                complexNote.murki=Shrutis;
              
            }
            if (comp.inner.kanBefore)
                {
                    complexNote.kanBefore=comp.inner.kanBefore?.shruti.value;
                    
                }
            if (comp.inner.mainShruti.value)
                {
                    complexNote.shruti=comp.inner.mainShruti.value;
                    
                }
                if (comp.inner.kanAfter)
                    {
                        complexNote.kanAfter=comp.inner.kanAfter?.shruti.value;
                   
                           
                    }
                    if (comp.inner.meendEnd)
                        {
                           complexNote.meendEnd=true;
                                 
                        }
        };
        return normalizeComplexNoteMem(complexNote) as ComplexNoteMem;
    }
    beatToMem(note :BeatSequenceNode)
    {
        let Note:{special:any,complexNote:any}={
            special:"",
            complexNote:null
        }
        let d=note;
        if (d.type=='ComplexNote')
        {
            let ret=this.complexNoteToMem(d.complexNote as ComplexNoteNode);
            if (ret)
             Note.complexNote=ret;
            
        }
        else if (d.type=="SILENCE")
            Note.special=Token.SILENCE
        if (d.type=='BREATH')
            Note.special+= Token.BREATH;
        if (d.type=='SUSTAIN')
            Note.special= Token.SUSTAIN;
        
        return Note;
    }
    
    phraseToMem(phrase:PhraseNode)
    {
        let phraseMem:PhraseMem={beatId: 0, carryMeend:false, gun:1, div:1, notes:[]}
        phrase.beats.forEach((d:BeatSequenceNode,ix)=>{
            if (phraseMem.notes) phraseMem?.notes.push( this.beatToMem(d));
        });

        if (phraseMem.notes)
            phraseMem.div=phraseMem.notes.length;
        return phraseMem;
    }
    VibhagToMem(vibhag:VibhagNode)
    {
        
        let vibhagMem:{id:number,beats:any[]}={id:0, beats:[]};
        vibhag.phrases.forEach ((phrase,indx )=>{
            vibhagMem.beats.push ( this.phraseToMem(phrase))
           
        })
        return vibhagMem;
    }
    toMem(measures:MeasureNode[])
    {
        let arMeasures :any[]=[];
        measures.forEach ((measure:MeasureNode)=>{
            let measureMem:MeasureMem
            ={id:0, vibhag:[] };
            measure.vibhags.forEach ((vibhag,ix)=>
            {
                measureMem.vibhag.push (this.VibhagToMem(vibhag));
                
            });
            arMeasures.push(measureMem)
            
        });
         return (arMeasures);
    }
    allowedGuns=[2 ,3 , 4 , 5, 7, 8, 1,6];

    curate(measures:MeasureMem[],tempo?:number, taal?:TaalType)
    {
    
        let carryMeend=false;
        measures.forEach ((measure:MeasureMem,ix)=>{
           measure.id=ix;
           let beat=0;
           
           measure.vibhag.forEach((vibhag:VibhagMem)=>{
            vibhag.startBeat=beat;
            if (measure.carryMeend)
                vibhag.carryMeend=true;
            else vibhag.carryMeend=false;

            vibhag.beats?.forEach((phrase:PhraseMem)=>{
               if (vibhag.carryMeend)
                phrase.carryMeend=true;
               else phrase.carryMeend=false;

                phrase.beatId=beat;
                beat++;
                //
                let thisGun=phrase.notes?.length;
                if (thisGun && (this.allowedGuns.find((gun)=>(thisGun==gun))))
                {
                phrase.notes?.forEach ((note:NoteMem)=>{
                    note.gunNumerator=thisGun;
                    note.duration=1/thisGun ;
                  
                        if (note.complexNote)
                        {
                            if (!carryMeend && note.complexNote.meendStart)
                            carryMeend=true;
                            else if (note.complexNote.meendEnd)
                            {
                                carryMeend=false;
                            }
                            else if (carryMeend)
                            {
                                if (note.complexNote.meendStart)
                                    throw ("Illegal meend start");
                               else note.complexNote.meendCont=true;
                            }
                            
                        }


                })


            
           }
           

        });
    
        // apply proper duration and gun
        // apply meend start/meendcont/meen end
        // tag measure id
        // tag vibhag id
        // add taal bol in vibag
        // add lyrics bol in vibhag
        

    });
});
}
compositionDisplay:any=[];

  }
  
   
  
    
  

 



export class Parser 
{
    sortedToken:any=[];
    arrageToken ()
    {
       let k= Object.keys(Token);
       let values= Object.values(Token);
       let ar:any=[];
       k.forEach ((ke,index)=>
       {
        ar.push ({key:ke, value: values[index]})
       });
       ar.sort ((a:any,b:any)=>{  return (a.value.length - b.value.lengh)

       })
       this.sortedToken=ar;

    }
    constructor()
    {
        this.arrageToken();
    }

    normalizeVibhagNotationSpacing(text: string): string
    {
      return text
        .split(/\r?\n/)
        .map((line) => {
          const trimmedLine = line.trim();
          if (!trimmedLine) {
            return "";
          }

          return trimmedLine
            .split(Token.MEASURE)
            .map((measure) =>
              measure
                .split(Token.VSEP)
                .map((vibhag) => vibhag.trim())
                .join(Token.VSEP)
                .trim()
            )
            .join(Token.MEASURE);
        })
        .join("\n");
    }

    preprocess(text:string)
    {
// Normalize whitespace and allow user-facing meend syntax `R( g m P)`
// while preserving ornament syntax like `(kR)` and `(mRG)`.
text=this.normalizeVibhagNotationSpacing(text);

let normalized = "";
const bracketStack: Array<"MEEND" | "ORNAMENT"> = [];

for (let ix = 0; ix < text.length; ix++) {
    const current = text[ix];
    const next = text[ix + 1];

    if (current === "[" && next === "(") {
        normalized += Token.MEENDSTART;
        bracketStack.push("MEEND");
        ix++;
        continue;
    }

    if (current === ")" && next === "]") {
        normalized += Token.MEENDEND;
        if (bracketStack[bracketStack.length - 1] === "MEEND") {
            bracketStack.pop();
        }
        ix++;
        continue;
    }

    if (current === "(") {
        if (next === "k" || next === "m") {
            normalized += current;
            bracketStack.push("ORNAMENT");
        } else {
            normalized += Token.MEENDSTART;
            bracketStack.push("MEEND");
        }
        continue;
    }

    if (current === ")") {
        const last = bracketStack.pop();
        if (last === "MEEND" && (next === Token.LOWER_OCATVE || next === Token.HIGHER_OCTAVE)) {
            normalized += next + Token.MEENDEND;
            ix++;
            continue;
        }
        normalized += last === "MEEND" ? Token.MEENDEND : current;
        continue;
    }

    normalized += current;
}

let newText=normalized.replace(/\s+/g," ",)
return newText;
    };

 
    compositionParser:null|CompositionParser=null;
    compositionNode:null|CompositionNode=null
    compositionMem:null|CompositionMem=null;
    compositionOmad:any=null;
    parse(text:string)
    {
        let preop=this.preprocess(text);

        
        // get all measures
        console.log('parsing ',preop)
        let tokens=this.parseText(preop)
        let myTokens:ParsedToken[]=[];
        tokens.forEach ((line,index)=>{
            line.forEach ((pt)=>{
                pt.lineNumber=index+1;
                myTokens.push(pt);
            })
        })
        let cparse=new CompositionParser(myTokens);
let compNode=cparse.parseComposition ();
console.log(compNode)
let result=cparse.toText(compNode.measures);
console.log(result);
let memresult=cparse.toMem(compNode.measures);
console.log(memresult);
cparse.curate(memresult);
this.compositionParser=cparse;
this.compositionMem={
    measures:memresult,
    tempo:60,
    taal:'Teental',
    beatsPerMeasure:16,
    vibhag:4
}



return ({tokens:myTokens, text:result, mem:memresult})
            
}

warning(m:string, line?:number)
{
    console.log("m");
}
  
  
  
   parseText(input: string): ParsedToken[][] {
    const tokenEntries = Object.entries(Token).sort((a, b) => b[1].length - a[1].length);
    const shrutiValues = Object.entries(Shruti);
  
    const allKnownStrings = [
      ...tokenEntries.map(([_, val]) => val),
      ...shrutiValues.map(([_, val]) => val)
    ].sort((a, b) => b.length - a.length);
  
    const tokenRegex = new RegExp(`(${allKnownStrings.map(v =>
      v.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
    ).join("|")}|[0-9]+)`, "g");
  
    const lines = input.split(/\r?\n/);
    const parsedLines: ParsedToken[][] = [];
  
    lines.forEach((line, lineIndex) => {
      const normalizedLine = line.trim().replace(/\s+/g, ' ');
      if (!normalizedLine) {
        return;
      }

      const matches = [...normalizedLine.matchAll(tokenRegex)].map(m => m[0]);
      const combined = matches.join('');
      const compactInput = normalizedLine;
  
      if (combined !== compactInput) {

        let arComb=combined.split('');
        let  arCompact=compactInput.split('');
        for (let ix=0; ix < arComb.length ; ix++)
        {
            console.log('Parsed ' ,arComb[ix],'compacted ',arCompact[ix], ' index ' ,ix )
            if (arCompact[ix])
            {
                if (arCompact[ix]!=arComb[ix])
                {
                    console.log('string differing at ',arCompact[ix],' ',arComb[ix],' index', ix)
                }
            }
        }


        throw new Error(`Invalid token found on line ${lineIndex + 1}: "${line}"`);
      }
  
      const parsedTokens: ParsedToken[] = [];
      const bracketStack: { type: "MEEND" | "ORNAMENT", token: string, index: number }[] = [];
  
      matches.forEach((token, i) => {
        const tokenMatch = tokenEntries.find(([_, val]) => val === token);
        if (tokenMatch) {
          const type = tokenMatch[0] as keyof typeof Token;
  
          // Openers
          if (type === "MEENDSTART") {
            bracketStack.push({ type: "MEEND", token, index: i });
          } else if (type === "KAN" || type === "MURKI") {
            bracketStack.push({ type: "ORNAMENT", token, index: i });
          }
  
          // Closers
          if (type === "MEENDEND") {
            const last = bracketStack.pop();
            if (!last || last.type !== "MEEND") {
              throw new Error(`Unmatched MEENDEND ')]' on line ${lineIndex + 1}`);
            }
          } else if (type === "CLOSEBRACKET") {
            const last = bracketStack.pop();
            if (!last || last.type !== "ORNAMENT") {
              throw new Error(`Unmatched CLOSEBRACKET ')' on line ${lineIndex + 1}`);
            }
          }
  
          parsedTokens.push({ value: token, type });
          return;
        }
  
        const shrutiMatch = shrutiValues.find(([_, val]) => val === token);
        if (shrutiMatch) {
          parsedTokens.push({ value: token, type: shrutiMatch[0] as keyof typeof Shruti });
          return;
        }
  
        if (/^\d+$/.test(token)) {
          parsedTokens.push({ value: token, type: "NUMBER", numberValue: Number(token) });
          return;
        }
  
        throw new Error(`Unexpected token: "${token}" on line ${lineIndex + 1}`);
      });
  
      // At end of line, stack must be empty
      if (bracketStack.length > 0) {
        const last = bracketStack[bracketStack.length - 1];
        const bracketType = last.type === "MEEND" ? "[(...)]" : "(k...) or (m...)";
        throw new Error(`Unclosed bracket ${bracketType} starting at token "${last.token}" on line ${lineIndex + 1}`);
      }
  
      parsedLines.push(parsedTokens);
    });
  
    return parsedLines;
  }

}
  
